import { Link } from "react-router-dom";
import DotWhite from "../assets/media/dot-white.svg";
// import FaceBookIcon from "../assets/media/facebook.svg";
// import InstagramIcon from "../assets/media/instagram.svg";
// import LinkedinIcon from "../assets/media/linkedin.svg";

const Footer = () => {
    return (
        <>
            <footer className="bg-dark py-6">
                <div className="container">
                    <div className="row justify-content-center justify-content-md-between gy-4">
                        <div className="col-md d-flex flex-wrap justify-content-center justify-content-md-start align-items-center gap-5">
                            <p className="fs-14 fw-normal text-white mb-0" >
                                &copy; {new Date().getFullYear()} Hitch
                            </p>
                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-3">
                                <Link to="/privacy-policy" className="fs-16 fw-normal text-white d-flex align-items-center gap-2">
                                    <img src={DotWhite} width={6} height={6} alt="dot-icon" loading="lazy" /> Privacy
                                </Link>
                                <Link to="/terms-conditions" className="fs-16 fw-normal text-white d-flex align-items-center gap-2">
                                    <img src={DotWhite} width={6} height={6} alt="dot-icon" loading="lazy" /> Terms & Conditions
                                </Link>
                            </div>
                        </div>
                        {/* <div className="col-md-auto">
                            <div className="d-flex justify-content-center align-items-center gap-3">
                                <Link to="#">
                                    <img
                                        className="img-fluid flex-shrink-0"
                                        src={FaceBookIcon}
                                        width={38}
                                        height={38}
                                        alt="Facebook"
                                        loading="lazy"
                                    />
                                </Link>
                                <Link to="#">
                                    <img
                                        className="img-fluid flex-shrink-0"
                                        src={InstagramIcon}
                                        width={38}
                                        height={38}
                                        alt="Instagram"
                                        loading="lazy"
                                    />
                                </Link>
                                <Link to="#">
                                    <img
                                        className="img-fluid flex-shrink-0"
                                        src={LinkedinIcon}
                                        width={38}
                                        height={38}
                                        alt="LinkedIn"
                                        loading="lazy"
                                    />
                                </Link>
                            </div>
                        </div> */}
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
